import summary from './modules/summary/summary'

export default {
  namespaced: true,
  modules: {
    summary,
  },
}
